import Table from 'antd/lib/table';
import Row from 'antd/lib/row';
import { Producer, Branch } from '../../Models/Report';
import React from 'react';

export interface IBranchListProps {
	selected: Producer[];
	onSelected: (producer: Producer, branchs: Branch[]) => void;
	selectedRowKeys?: any;
}

export interface IProducerComponentProps {
	selected: Producer;
	onSelected: (producer: Producer, branchs: Branch[]) => void;
	selectedRowKeys?: any[];
}

const ProducerComponent = (props: IProducerComponentProps) => {
	const p = props.selected;
	const [selected, setSelected] = React.useState(
		props.selectedRowKeys
			? props.selectedRowKeys.map(
					(k: string) => `row-selection-${props.selected.id}-${k}`
			  )
			: []
	);
	return (
		<Table
			style={{ marginBottom: '15px'}}
			rowKey={(record: Branch, index: number) =>
				`row-selection-${p.id}-${record.id}`
			}
			pagination={false}
			rowSelection={{
				onChange: (selectedRowKeys: any, selectedRows: any) => {
					setSelected(selectedRowKeys);
					props.onSelected(p, selectedRows);
				},
				getCheckboxProps: (record: any) => ({
					disabled: record.name === 'Disabled User', // Column configuration not to be checked
					name: record.name
				}),
				selectedRowKeys: selected
			}}
			dataSource={p.branchs}>
			<Table.Column title={p.name} dataIndex='name' />
		</Table>
	);
};

const BranchList = (props: IBranchListProps) => {
	return (
		<Row type='flex'>
			{props.selected.map(p => (
				<ProducerComponent
					key={`selection-producer-${p.id}`}
					selected={p}
					onSelected={props.onSelected}
					selectedRowKeys={
						props.selectedRowKeys ? props.selectedRowKeys[p.id] : []
					}
				/>
			))}
		</Row>
	);
};

export default BranchList;
